
import React from "react";
import { Button } from "@/components/ui/button";

interface CancelButtonProps {
  onCancelLastEntry: () => void;
  currentPoint: string;
  currentAttempt: number;
  firstPoint: string;
}

const CancelButton: React.FC<CancelButtonProps> = ({
  onCancelLastEntry,
  currentPoint,
  currentAttempt,
  firstPoint
}) => {
  const cancelButtonDisabled = currentPoint === firstPoint && currentAttempt === 0;

  return (
    <Button 
      onClick={onCancelLastEntry} 
      className={`h-12 font-medium ${
        cancelButtonDisabled 
          ? "bg-red-100 text-red-400" 
          : "bg-red-200 hover:bg-red-300 text-red-700"
      } border-0 w-full mt-2`}
      disabled={cancelButtonDisabled}
    >
      Annuler dernière saisie
    </Button>
  );
};

export default CancelButton;
